module.exports = __webpack_public_path__ + "static/assets/a9c2390d9fe6ae4347ebc4e572a11fae.svg";